import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageComponent } from '@/components/Image';
import { LOCALE_OFFERS, WELCOME_OFFER_SRC_PATH } from './helpers';
import { ScWelcomeOfferCard } from './styled';

interface IWelcomeOfferCard {
  translation: string;
}

export const WelcomeOfferCard: FC<IWelcomeOfferCard> = ({ translation }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation(['dragonPearlsCoverflowLPTemplate', translation]);

  const descriptionKey = t('welcomeOfferCard.description', {
    defaultValue: '',
    ns: translation,
  });

  const offerImg = useMemo(
    () =>
      `${WELCOME_OFFER_SRC_PATH}/${LOCALE_OFFERS[language] ?? 'prize-default'}.webp`,
    [language]
  );

  return (
    <ScWelcomeOfferCard
      className={`${language}`}
      withDescription={!!descriptionKey}
    >
      <div className="header">
        <p className="title">{t('welcomeOfferCard.title')}</p>
        <ImageComponent
          alt="offer"
          className="offer-img"
          height={190}
          src={offerImg}
          width={524}
        />
        {descriptionKey && <p className="description">{descriptionKey}</p>}
      </div>
      <div className="offer-steps">
        <div className="offer-step">
          <p className="title">{t('welcomeOfferCard.bonus1.title')}</p>
          <p className="description">{t('welcomeOfferCard.bonus1.content')}</p>
        </div>
        <div className="offer-step">
          <p className="title">{t('welcomeOfferCard.bonus2.title')}</p>
          <p className="description">{t('welcomeOfferCard.bonus2.content')}</p>
        </div>
        <div className="offer-step">
          <p className="title">{t('welcomeOfferCard.bonus3.title')}</p>
          <p className="description">{t('welcomeOfferCard.bonus3.content')}</p>
        </div>
        <div className="offer-step">
          <p className="title">{t('welcomeOfferCard.bonus4.title')}</p>
          <p className="description">{t('welcomeOfferCard.bonus4.content')}</p>
        </div>
        <div className="offer-step">
          <p className="title">{t('welcomeOfferCard.bonus5.title')}</p>
          <p className="description">{t('welcomeOfferCard.bonus5.content')}</p>
        </div>
      </div>
    </ScWelcomeOfferCard>
  );
};
